module.exports = __webpack_public_path__ + "static/poster-7de64d02039bc302668d7ce3c08c19fe.jpg";